(() => {
  'use strict';
  const host = document.querySelector('mcase-color-customizer');
  const summary = host?.querySelector('[data-selection-colors]');
  if (!summary) return;

  function renderColors() {
    if (!host.config?.parts || !host.colors || !host.selection) return;
    const selection = host.config.parts.map(part => ({
      part,
      color: host.colors.get(host.selection[part.id])
    }));
    if (selection.some(item => !item.color)) return;
    summary.replaceChildren(...selection.map(({ part, color }) => {
      const dot = document.createElement('span');
      dot.className = 'sm-mcase__selection-dot';
      dot.style.setProperty('--part-color', color.hex);
      dot.title = `${part.label}: ${color.label}`;
      dot.setAttribute('aria-hidden', 'true');
      return dot;
    }));
    summary.setAttribute('aria-label', selection.map(({ part, color }) => `${part.label}: ${color.label}`).join(', '));
  }

  host.addEventListener('mcase:price-change', renderColors);
  renderColors();
})();
